'use client';
import React, { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';
import SvgArrow from '@/public/svg/Arrow';
import Socials from '@/app/components/ui-elements/socials';
import PagesService from '@/app/services/pages';
import { BASE_URL } from '@/app/contants/url';

export default function ProjectContent({ params }: { params: any }) {
    const t = useTranslations('Projects');
    const [data, setData] = useState<any>(null)
    const [error, setError] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    async function getPageDetails() {
        setIsLoading(true)
        try {
            const result: any = await PagesService.getPage(params?.slug);
            if (result?.data?.success) {
                setData(result?.data?.data)
                setError(false)
            } else {
                setError(true)
            }
        } catch (error: any) {
            setError(true)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => { getPageDetails() }, [])

    return (
        <div className='mb-10 mt-20 px-4 md:px-20 text-start'>
            <div className='flex flex-col md:flex-row justify-start pb-4'>
                <div className='flex-3 border-r-1 border-slate-100'>
                    <div className='pb-16'>
                        <h1 className='text-3xl md:text-[77px] leading-none text-start font-regular uppercase'>
                            {data?.title}
                        </h1>
                        <h2 className='text-sm md:text-lg leading-normal mt-6'>
                            {data?.description}
                        </h2>
                    </div>
                </div>
                <div className='flex-1'>
                    <div className='pb-10'>
                        <h2 className='text-sm md:text-md leading-normal mt-6 ps-8 uppercase text-gray-300'>
                            share
                        </h2>
                        <Socials />
                    </div>
                </div>
            </div>
            <Image
                src={`${BASE_URL}storage/${data?.cover_photo[0]?.path}`}
                width={600}
                height={300}
                alt={`Project ${data?.title}`}
                className="w-full h-auto mt-2"
                style={{ objectFit: "cover", width: '100%' }}
                sizes="(max-width: 768px) 100vw, 33vw"
            />
            <div className='flex flex-col md:flex-row justify-start pb-8 pt-4'>
                <div className='flex-3'>
                    <div className='pb-16'>
                        <div className='flex flex-col md:flex-row gap-4 mt-10 justify-start items-center'>
                            {data?.sections[0]?.image_path?.length > 0 && (
                                <Image
                                    src={`${BASE_URL}storage/${data?.sections[0]?.image_path}`}
                                    width={400}
                                    height={500}
                                    alt={`Project_photo`}
                                    className="h-auto"
                                    style={{ width: '40%' }}
                                />
                            )}
                            <div style={{ width: '60%'}}>
                                <h2 className='text-sm md:text-2xl font-semibold leading-normal mt-6 px-4'>
                                    {data?.sections[0]?.title ?? ""}
                                </h2>
                                <h2 className='text-sm md:text-lg leading-normal mt-6 px-4'>
                                    {data?.sections[0]?.description ? (
                                        <div style={{ textAlign: "justify" }}
                                            dangerouslySetInnerHTML={{
                                                __html: `
                                                    <style>
                                                    </style>
                                                    ${data?.sections[2]?.description}
                                                    `,
                                            }} />
                                    ) : (
                                        <></>
                                    )}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex flex-col md:flex-row justify-start pb-8 pt-4'>
                <div className='flex-3'>
                    <div className='pb-16'>
                        <div className='flex flex-col md:flex-row gap-4 mt-10 justify-start items-center'>
                            <div style={{ width: '60%'}}>
                                <h2 className='text-sm md:text-2xl font-semibold leading-normal mt-6 px-4'>
                                   {data?.sections[1]?.title ?? ""}
                                </h2>
                                <h2 className='text-sm md:text-lg leading-normal mt-6 px-4'>
                                   {data?.sections[1]?.description ? (
                                        <div style={{ textAlign: "justify" }}
                                            dangerouslySetInnerHTML={{
                                                __html: `
                                                    <style>
                                                    </style>
                                                    ${data?.sections[2]?.description}
                                                    `,
                                            }} />
                                    ) : (
                                        <></>
                                    )}
                                </h2>
                            </div>
                            {data?.sections[1]?.image_path?.length > 0 && (
                                <Image
                                    src={`${BASE_URL}storage/${data?.sections[1]?.image_path}`}
                                    width={400}
                                    height={500}
                                    alt={`Project_photo`}
                                    className="h-auto"
                                    style={{ width: '40%' }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex flex-col md:flex-row justify-start pb-8 pt-4'>
                <div className='flex-3'>
                    <div className='pb-16'>
                        <div className='flex flex-col md:flex-col gap-4 mt-10 justify-start items-center'>
                            {data?.sections[2]?.image_path?.length > 0 && (
                                <Image
                                    src={`${BASE_URL}storage/${data?.sections[2]?.image_path}`}
                                    width={400}
                                    height={500}
                                    alt={`Project_photo`}
                                    className="h-auto"
                                    style={{ width: '40%' }}
                                />
                            )}
                            <div style={{ width: '60%'}}>
                                <h2 className='text-sm md:text-2xl font-semibold leading-normal mt-6 px-4'>
                                    {data?.sections[2]?.title ?? ""}
                                </h2>
                                <h2 className='text-sm md:text-lg leading-normal mt-6 px-4'>
                                    {data?.sections[2]?.description ? (
                                        <div style={{ textAlign: "justify" }}
                                            dangerouslySetInnerHTML={{
                                                __html: `
                                                    <style>
                                                    </style>
                                                    ${data?.sections[2]?.description}
                                                    `,
                                            }} />
                                    ) : (
                                        <></>
                                    )}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
